import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axiosInstance from '../api/axiosInstance';

const ContentPage = () => {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    axiosInstance.get(`/content/by-url/${slug}`)
      .then(res => setData(res.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <div className="p-4 text-red-600">Seite nicht gefunden.</div>;
  if (!data) return <div className="p-4">Lade Inhalt...</div>;

  return (
<div className="max-w-4xl mx-auto p-6 bg-white text-gray-900 dark:bg-gray-900 dark:text-gray-100 rounded shadow">
<h1 className="text-3xl font-bold mb-4">{data.title}</h1>
      <div
        className="prose dark:prose-invert max-w-none"
        dangerouslySetInnerHTML={{ __html: data.content }}
      />
    </div>
  );
};

export default ContentPage;
